import { useState, useEffect, useCallback, useRef } from 'react'
import HealthService from 'service/HealthService'
import { IDoctorSpecialtyList } from 'types/HealthType'

export default function useGetDoctorSpecialtyList(
  locationId: number | undefined,
  hasLocationList: boolean = false,
  locationIds?: number[]
) {
  const [data, updateData] = useState<IDoctorSpecialtyList[]>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)
  const isMountedRef = useRef(true)

  const fetchData = useCallback(() => {
    if (!isMountedRef.current) return
    setIsLoading(true)
    if (hasLocationList && !!locationIds?.length) {
      HealthService.getSpecialtiesByLocationIds({ LocationIds: locationIds })
        .then((r) => {
          if (isMountedRef.current) {
            updateData(r.data)
          }
        })
        .catch((err) => {
          if (isMountedRef.current) {
            setError(true)
          }
        })
        .finally(() => {
          if (isMountedRef.current) {
            setIsLoading(false)
          }
        })
    } else if (!!locationId) {
      HealthService.getSpecialtiesByLocationId(locationId)
        .then((r) => {
          if (isMountedRef.current) {
            updateData(r.data)
          }
        })
        .catch((err) => {
          if (isMountedRef.current) {
            setError(true)
          }
        })
        .finally(() => {
          if (isMountedRef.current) {
            setIsLoading(false)
          }
        })
    } else return
  }, [hasLocationList, locationId, locationIds])

  useEffect(() => {
    return () => {
      isMountedRef.current = false
    }
  }, [])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return { data, isLoading, error }
}
